import {
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input as ChakraInput,
} from '@chakra-ui/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

const Input = ({ label, name, type = 'text', ...inputProps }) => {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  return (
    <FormControl isInvalid={errors?.[name]?.message} mb={4}>
      <FormLabel htmlFor={name}>{label}</FormLabel>
      <ChakraInput type={type} {...register(name)} {...inputProps} />
      <FormErrorMessage>{errors?.[name]?.message}</FormErrorMessage>
    </FormControl>
  );
};

export default Input;
